// src/common/log-levels.ts
var LogLevels = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  CRITICAL: 4
};
var LevelNameMap = {
  0: "DEBUG",
  1: "INFO",
  2: "WARN",
  3: "ERROR",
  4: "CRITICAL"
};

// src/common/logfmt.ts
var LOG_LEVEL_COLORS = {
  [LogLevels.CRITICAL]: "\x1B[31m",
  // Red
  [LogLevels.ERROR]: "\x1B[31m",
  // Red
  [LogLevels.WARN]: "\x1B[33m",
  // Yellow
  [LogLevels.INFO]: "\x1B[32m",
  // Green
  [LogLevels.DEBUG]: "\x1B[36m"
  // Cyan
};
var RESET_COLOR = "\x1B[0m";
function stringify(...data) {
  let line = "";
  for (let i = 0; i < data.length; i++) {
    const [key, valueRaw] = data[i];
    let isNull = false;
    let valueString;
    if (valueRaw == null) {
      isNull = true;
      valueString = "";
    } else {
      valueString = valueRaw.toString();
    }
    const needsQuoting = valueString.indexOf(" ") > -1 || valueString.indexOf("=") > -1;
    const needsEscaping = valueString.indexOf('"') > -1 || valueString.indexOf("\\") > -1;
    valueString = valueString.replace(/\n/g, "\\n");
    if (needsEscaping) valueString = valueString.replace(/["\\]/g, "\\$&");
    if (needsQuoting || needsEscaping) valueString = `"${valueString}"`;
    if (valueString === "" && !isNull) valueString = '""';
    if (LOGGER_CONFIG.enableColor) {
      let color = "\x1B[2m";
      if (key === "level") {
        const level = LogLevels[valueString];
        const levelColor = LOG_LEVEL_COLORS[level];
        if (levelColor) {
          color = levelColor;
        }
      } else if (key === "msg") {
        color = "\x1B[32m";
      } else if (key === "trace") {
        color = "\x1B[34m";
      }
      line += `\x1B[0m\x1B[1m${key}\x1B[0m\x1B[2m=\x1B[0m${color}${valueString}${RESET_COLOR}`;
    } else {
      line += `${key}=${valueString}`;
    }
    if (i !== data.length - 1) {
      line += " ";
    }
  }
  return line;
}
function castToLogValue(v) {
  if (typeof v === "string" || typeof v === "number" || typeof v === "boolean" || v === null || v === void 0) {
    return v;
  }
  if (v instanceof Error) {
    return String(v);
  }
  try {
    return JSON.stringify(v);
  } catch {
    return "[cannot stringify]";
  }
}
var LOGGER_CONFIG = {
  enableColor: false,
  enableSpreadObject: false,
  enableErrorStack: false
};

// src/common/log.ts
var Logger = class {
  name;
  level;
  constructor(name, level) {
    this.name = name;
    this.level = level;
  }
  log(level, message, ...args) {
    const record = {
      msg: message,
      args,
      level,
      loggerName: this.name,
      datetime: /* @__PURE__ */ new Date(),
      levelName: LevelNameMap[level]
    };
    if (this.#shouldLog(level)) {
      this.#logRecord(record);
    }
  }
  #shouldLog(level) {
    return level >= LogLevels[this.level];
  }
  #logRecord(record) {
    console.log(formatter(record));
  }
  debug(message, ...args) {
    this.log(LogLevels.DEBUG, message, ...args);
  }
  info(message, ...args) {
    this.log(LogLevels.INFO, message, ...args);
  }
  warn(message, ...args) {
    this.log(LogLevels.WARN, message, ...args);
  }
  error(message, ...args) {
    this.log(LogLevels.ERROR, message, ...args);
  }
  critical(message, ...args) {
    this.log(LogLevels.CRITICAL, message, ...args);
  }
};
var loggers = {};
function getLogger(name = "default") {
  const defaultLogLevelEnv = typeof process !== "undefined" ? process.env._LOG_LEVEL : void 0;
  const defaultLogLevel = defaultLogLevelEnv ?? "INFO";
  if (!loggers[name]) {
    loggers[name] = new Logger(name, defaultLogLevel);
  }
  return loggers[name];
}
function formatter(log) {
  const args = [];
  for (let i = 0; i < log.args.length; i++) {
    const logArg = log.args[i];
    if (logArg && typeof logArg === "object") {
      for (const k in logArg) {
        const v = logArg[k];
        pushArg(k, v, args);
      }
    } else {
      pushArg(`arg${i}`, logArg, args);
    }
  }
  return stringify(
    //["ts", formatTimestamp(log.datetime)],
    ["level", LevelNameMap[log.level]],
    //["target", log.loggerName],
    ["msg", log.msg],
    ...args
  );
}
function pushArg(k, v, args) {
  args.push([k, castToLogValue(v)]);
}
function setupLogging() {
}

export {
  Logger,
  getLogger,
  setupLogging
};
//# sourceMappingURL=chunk-TGNFA6PQ.js.map